module.exports = __webpack_public_path__ + "media/images/front/responsive/institution-detail-rich/step03-10afdc2b5b2dcd566a820902efe2dfa0.png";